// extracted by mini-css-extract-plugin
export default {"faqWrapper":"Faq_faqWrapper__aJVNy","faqContentWrapper":"Faq_faqContentWrapper__7iM7+","Container":"Faq_Container__IDUfJ","header":"Faq_header__of-Gc"};